interface GistProps {
  gistFile?: string;
}

export default function Gist({ gistFile }: GistProps) {
  return (
    <iframe
      title="Gist File"
      width="100%"
      height="500px"
      seamless
      allowFullScreen
      src={`data:text/html;charset=utf-8,<head><base target='_blank' /></head><body><script src='${gistFile}'></script></body>`}
    />
  );
}
